module.exports = __webpack_public_path__ + "static/media/input.b5b81c4c.svg";